import { faBible, faChurch, faGlobe, faHandshake } from "@fortawesome/free-solid-svg-icons"


export const HomeFourDivChildArray = [

    {route:"/bibleverse",text:"Bible Verses",image:"../assets/images/main/church.webp", },
    {text:"Upcoming Events",image:"../assets/images/main/cross_two.webp"},
    {route:"/contact",text:"Need Prayer?",image:"../assets/images/main/cross.webp"},
    {route:"/about",text:"Our Mission",image:"../assets/images/main/jesus-neon.webp"},
]

export const AboutOurMissionArray = [

    {icon: faChurch, textPara:"Experience Spirit-filled and uplifting worship services.", titleName:"Worship"},
    {icon: faHandshake, textPara:"Foster a supportive and inclusive environment for all.", titleName:"Community"},
    {icon: faBible, textPara:"Provide opportunities for spiritual growth through Bible studies and life groups.", titleName:"Growth"},
    {icon: faGlobe, textPara:"Serve our local and global communities through various missions and charitable activities.", titleName:"Outreach"},
]

export const ContactDetailsArray = [

    {icon: faChurch, textPara:"Experience Spirit-filled and uplifting worship services.", titleName:"Worship"},
    
]

export const Events = [

    {eventName: 'Youth Meeting' , date :'June 8th'},
    {eventName: 'Fasting Prayer' , date :'June 13th, 14th, 15th'}   

]